import { render, staticRenderFns } from "./pkg24.vue?vue&type=template&id=981510be&"
import script from "./pkg24.vue?vue&type=script&lang=js&"
export * from "./pkg24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports